/**
 * @flow
 * @relayHash 8cd49b0ec06bc50c695893a894d383a7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BlockedUserInput = {
  userId: string
};
export type BlockedUserMutationVariables = {|
  input: BlockedUserInput
|};
export type BlockedUserMutationResponse = {|
  +BlockedUser: ?{|
    +error: ?string
  |}
|};
export type BlockedUserMutation = {|
  variables: BlockedUserMutationVariables,
  response: BlockedUserMutationResponse,
|};
*/


/*
mutation BlockedUserMutation(
  $input: BlockedUserInput!
) {
  BlockedUser(input: $input) {
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "BlockedUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "BlockedUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "BlockedUserInput!"
      }
    ],
    "concreteType": "BlockedUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BlockedUserMutation",
  "id": null,
  "text": "mutation BlockedUserMutation(\n  $input: BlockedUserInput!\n) {\n  BlockedUser(input: $input) {\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BlockedUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "BlockedUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '535936764082e1c5acb341b734487ff8';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/BlockedUserMutation.graphql.js